import { createFileRoute } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import UsersPage from 'src/modules/users/components/pages/users.page';
import { userSearchSchema } from 'src/modules/shared/schemas/user.schema';

export const Route = createFileRoute('/users/')({
  component: UsersLayoutComponent,
  validateSearch: (search) => userSearchSchema.parse(search),
});

function UsersLayoutComponent() {
  return (
    <AuthenticateRoute>
      <UsersPage />
    </AuthenticateRoute>
  );
}
